import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	modalContainer: {
		...CssSelectors.allDescendants(
			{
				padding: 0,
			},
			'.modal-overlay-content'
		),
	},
	modalHeader: {
		backgroundColor: brandPrimary,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	container: {
		width: 720,
		maxHeight: 'calc(100vh - 80px)',
		overflow: 'auto',
		paddingLeft: 36,
		paddingRight: 36,
		boxSizing: 'border-box',
	},
	header: {
		fontSize: 24,
		marginTop: 24,
		marginBottom: 24,
	},
	previewContainer: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		marginBottom: 16,
		minHeight: 200,
		position: 'relative' as const,
	},
	previewIframe: {
		width: '100%',
		height: 400,
		border: 'none',
		borderRadius: THEME.common.borderRadius,
	},
	previewPlaceholder: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 200,
		color: THEME.colors.text.light,
		fontSize: 14,
	},
	previewLoading: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 200,
	},
	footer: {
		marginBottom: 24,
		display: 'flex',
		gap: 12,
	},
	label: {
		fontSize: 14,
		fontWeight: 600,
		margin: 0,
	},
	labelRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		marginBottom: 8,
	},
	helpLink: {
		fontSize: 12,
		color: brandPrimary,
		cursor: 'pointer',
		textDecoration: 'underline',
		':hover': {
			textDecoration: 'none',
		},
	},
	helpTooltip: {
		maxWidth: 360,
		padding: 16,
		fontSize: 13,
		lineHeight: '1.5',
	},
	section: {
		marginBottom: 16,
	},
	emptyState: {
		padding: '24px 16px',
		textAlign: 'center' as const,
		color: THEME.colors.text.light,
		fontSize: 14,
	},
	yearFilterContainer: {
		display: 'flex',
		gap: 8,
		flexWrap: 'wrap' as const,
	},
	yearButton: {
		padding: '6px 16px',
		borderRadius: 20,
		border: THEME.common.border,
		background: 'none',
		cursor: 'pointer',
		fontSize: 14,
		color: THEME.colors.text.main,
		':hover': {
			backgroundColor: THEME.colors.background.main,
		},
	},
	yearButtonActive: {
		backgroundColor: brandPrimary,
		borderColor: brandPrimary,
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: brandPrimary,
		},
	},
	paginationBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 16,
		marginBottom: 12,
	},
	paginationButton: {
		padding: '4px 12px',
		borderRadius: 4,
		border: THEME.common.border,
		background: 'none',
		cursor: 'pointer',
		fontSize: 13,
		color: brandPrimary,
		':hover': {
			backgroundColor: THEME.colors.background.main,
		},
		':disabled': {
			color: THEME.colors.text.light,
			cursor: 'default',
		},
	},
	paginationText: {
		fontSize: 13,
		color: THEME.colors.text.main,
		fontWeight: 600,
	},
});
